import {inlineError} from '@s-ui/decorators'

import {SellerRepository} from './SellerRepository.js'

/**
 * @class
 * @implements SellerRepository
 */
export class LocalStorageSellerRepository extends SellerRepository {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Config} deps.config
   * @param {Storage} deps.localStorage
   * @param {Function} deps.contactDetailsVOFactory
   * @param {Function} deps.instantOfferEntityFactory
   */
  constructor({config, localStorage, contactDetailsVOFactory, instantOfferEntityFactory}) {
    super({localStorage})

    this._config = config
    this._contactConfig = this._config.get('contact')
    this._lastContactDetailsKey = this._contactConfig.LAST_CONTACT_DETAIL_KEY
    this._sellerConfig = this._config.get('seller')
    this._lastInstantOfferDetails = this._sellerConfig.LAST_INSTANT_OFFER_DETAILS_KEY
    this._vehicleStandaloneDraftKey = this._sellerConfig.VEHICLE_STANDALONE_DRAFT_KEY
    this._localStorage = localStorage
    this._contactDetailsVOFactory = contactDetailsVOFactory
    this._instantOfferEntityFactory = instantOfferEntityFactory
  }

  @inlineError
  getInstantOfferDetails({instantOfferEntity}) {
    const instantOfferDetails = this._localStorage.getItem(this._lastInstantOfferDetails)

    if (!instantOfferDetails) return Promise.resolve()

    const instantOfferId = instantOfferEntity.getId()
    const instantOfferDetailsParsed = JSON.parse(instantOfferDetails)

    return instantOfferId === instantOfferDetailsParsed.instantOfferId
      ? Promise.resolve(this._instantOfferEntityFactory(instantOfferDetailsParsed))
      : Promise.resolve()
  }

  @inlineError
  async saveContactDetails({adId, message, name, email, phone, zipCode}) {
    this._localStorage.setItem(
      this._lastContactDetailsKey,
      JSON.stringify({adId, message, name, email, phone, date: Date.now(), zipCode})
    )

    return Promise.resolve()
  }

  @inlineError
  saveInstantOfferDetails({instantOfferEntity, contactDetails}) {
    const data = {
      ...instantOfferEntity.toJSON(),
      ...(contactDetails && {contactDetails})
    }
    this._localStorage.setItem(this._lastInstantOfferDetails, JSON.stringify(data))

    return Promise.resolve()
  }

  @inlineError
  getVehicleDraft() {
    try {
      const vehicleDraft = this._localStorage.getItem(this._vehicleStandaloneDraftKey)

      return Promise.resolve(vehicleDraft ? JSON.parse(vehicleDraft) : null)
    } catch {
      return Promise.resolve(null)
    }
  }

  @inlineError
  saveVehicleDraft({vehicleDraft}) {
    this._localStorage.setItem(this._vehicleStandaloneDraftKey, JSON.stringify(vehicleDraft))
    return Promise.resolve()
  }

  @inlineError
  clearVehicleDraft() {
    this._localStorage.removeItem(this._vehicleStandaloneDraftKey)
    return Promise.resolve()
  }

  @inlineError
  async getLastContactDetails() {
    const rawLastContactDetails = JSON.parse(this._localStorage.getItem(this._lastContactDetailsKey))

    if (!rawLastContactDetails) return Promise.resolve()

    return this._contactDetailsVOFactory({
      adId: rawLastContactDetails.adId,
      message: rawLastContactDetails.message,
      name: rawLastContactDetails.name,
      email: rawLastContactDetails.email,
      phone: rawLastContactDetails.phone,
      date: rawLastContactDetails.date,
      zipCode: rawLastContactDetails.zipCode
    })
  }
}
